export default ({
  namespaced: true,

  state: {
    formSubmitted: false,
    validatedForms: 0,
    totalForms: 3
  },
  
  getters: {
    formSubmitted: state => state.formSubmitted,
    validatedForms: state => state.validatedForms,
    totalForms: state => state.totalForms
  },

  mutations: {
    setFormSubmitted(state, value) {
      if (value)
        state.formSubmitted = true
      else
        state.formSubmitted = false
      
      console.log('formSubmitted', state.formSubmitted)
    },
    resetFormSubmitted(state) {
      state.formSubmitted = false
      // state.validatedForms = 0
    },
    clearStoreData(state) {
      state.formSubmitted = false
      state.validatedForms = 0
    },
    setValidatedForms(state, value) {
      if (value)
        state.validatedForms++
      // else
      //   state.validatedForms--
    }
  },

  actions: {
    //
  }
})